// src/store/store.js
import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./slice/authSlice";
import restrictedAccessReducer from "./slice/restrictedAccessSlice";

export const store = configureStore({
    reducer: {
        auth: authReducer,
        restrictedAccess: restrictedAccessReducer,
    },
});
